import { Grid, Paper, Skeleton, Stack } from '@mui/material';

/**
 * Loading list layout.
 *
 * @param {number} tabs - The amount of tabs of the loading list layout.
 *
 * @param {boolean} title - A boolean to show a skeleton as title of the loading list layout.
 *
 * @param {number} buttons - The amount of action buttons of the loading list layout.
 *
 * @return {React.JSX.Element} The rendered LoadingListLayout component.
 */
export const LoadingListLayout = ({ tabs, title, buttons }: { tabs?: number; title?: boolean; buttons?: number }) => {
  return (
    <Paper sx={{ width: '100%', height: '100%', padding: 4 }} data-testid="loadinglist-layout">
      {!!tabs && (
        <Grid
          container
          sx={{
            borderBottom: 1,
            borderColor: 'divider',
            flexDirection: 'row',
            flexWrap: 'nowrap',
            justifyContent: 'space-between',
            alignItems: 'center',
            paddingBottom: 0.5,
          }}
        >
          <Stack direction="row" width="100%" gap={0.5}>
            {[...Array(tabs)].map((_, key) => (
              <Skeleton
                key={key}
                variant="rounded"
                animation="wave"
                sx={{ width: { xs: '15%', lg: '10%' }, height: 48 }}
              />
            ))}
          </Stack>
        </Grid>
      )}
      <Stack direction="row" width="100%" justifyContent="space-between" padding={2}>
        {title && <Skeleton variant="rounded" animation="wave" sx={{ width: { xs: '70%', lg: '30%' }, height: 36 }} />}
        {!!buttons && (
          <Stack direction="row" width="100%" justifyContent="flex-end" gap={2}>
            {[...Array(buttons)].map((_, key) => (
              <Skeleton key={key} variant="circular" animation="wave" sx={{ width: 36, height: 36 }} />
            ))}
          </Stack>
        )}
      </Stack>
      <Stack direction="column" width="100%" gap={2}>
        {[...Array(8)].map((_, key) => (
          <Skeleton key={key} variant="rounded" animation="wave" sx={{ width: '100%', height: 64 }} />
        ))}
      </Stack>
    </Paper>
  );
};
